import { Type } from '@sinclair/typebox';
const deliveryEstimateSchema = Type.Object({
    minDate: Type.Number(),
    maxDate: Type.Number(),
    minDays: Type.String(),
    maxDays: Type.String(),
});
const priceSchemaTax = Type.Object({
    amountInclTax: Type.Number(),
    amountExclTax: Type.Number(),
    taxPercentage: Type.Number(),
});
const priceSchemaVat = Type.Object({
    amountInclVat: Type.Number(),
    amountExclVat: Type.Number(),
    taxPercentage: Type.Number(),
});
const totalAmountForFreeShipping = Type.Object({
    normal: Type.Union([Type.Number(), Type.Null()]),
    fast: Type.Union([Type.Number(), Type.Null()]),
    express: Type.Union([Type.Number(), Type.Null()]),
});
const shippingMethod = Type.Object({
    id: Type.String(),
    name: Type.String(),
    title: Type.String(),
    type: Type.String(),
    image: Type.Object({
        url: Type.String(),
        alt: Type.String(),
    }),
    deliveryEstimate: deliveryEstimateSchema,
});
const shippingMethodTaxSchema = Type.Intersect([
    shippingMethod,
    Type.Object({
        price: Type.Object({
            total: priceSchemaTax,
            delivery: priceSchemaTax,
            handling: priceSchemaTax,
        }),
    }),
]);
const shippingMethodVatSchema = Type.Intersect([
    shippingMethod,
    Type.Object({
        price: Type.Object({
            total: priceSchemaTax,
            delivery: priceSchemaVat,
            handling: priceSchemaVat,
        }),
    }),
]);
export const shippingOptionsList = Type.Object({
    totalAmountForFreeShipping: Type.Union([totalAmountForFreeShipping, Type.Null()]),
    list: Type.Optional(Type.Array(shippingMethodTaxSchema)),
});
export const shippingOptionsListVat = Type.Object({
    totalAmountForFreeShipping: Type.Union([totalAmountForFreeShipping, Type.Null()]),
    list: Type.Optional(Type.Array(shippingMethodVatSchema)),
});
//# sourceMappingURL=shipping.js.map